import { useCallback, useState } from 'react';
import { ModalState } from '../types';

export interface CardModalState {
  modal: ModalState;
  openModal: (id: number, deck?: number[]) => void;
  closeModal: () => void;
  goPrev: () => void;
  goNext: () => void;
}

const initialState: ModalState = { cardId: null, deck: [], deckIdx: 0 };

export const useCardModal = (): CardModalState => {
  const [modal, setModal] = useState<ModalState>(initialState);

  const openModal = useCallback((id: number, deck?: number[]): void => {
    const d = deck && deck.length ? [...deck] : [id];
    let idx = d.indexOf(id);
    if (idx < 0) idx = 0;
    setModal({ cardId: id, deck: d, deckIdx: idx });
  }, []);

  const closeModal = useCallback((): void => {
    setModal(initialState);
  }, []);

  const goPrev = useCallback((): void => {
    setModal(prev => {
      if (prev.deckIdx <= 0) return prev;
      const deckIdx = prev.deckIdx - 1;
      return { ...prev, deckIdx, cardId: prev.deck[deckIdx] };
    });
  }, []);

  const goNext = useCallback((): void => {
    setModal(prev => {
      if (prev.deckIdx >= prev.deck.length - 1) return prev;
      const deckIdx = prev.deckIdx + 1;
      return { ...prev, deckIdx, cardId: prev.deck[deckIdx] };
    });
  }, []);

  return { modal, openModal, closeModal, goPrev, goNext };
};
